import { initializePermissionApi, PermissionApi } from '@data-delivery/permission-ui-api';
import { useQuery } from '@tanstack/react-query';
import type { BusinessGroupEntity } from './business-groups-keys';
import { businessGroupsKeys } from './business-groups-keys';

const api = initializePermissionApi(PermissionApi.BusinessGroupsApi);

export function useBusinessGroupsRQ() {
  return useQuery(businessGroupsKeys.listQuery());
}

export function useBusinessGroupByIdRQ(id: string | undefined) {
  const keyId = id ?? '__no_id__';
  return useQuery<BusinessGroupEntity | undefined>({
    queryKey: businessGroupsKeys.byId(keyId),
    async queryFn() {
      if (!id) {
        return undefined;
      }

      const { data } = await api.getOrSearchBusinessGroups({ id });
      return Array.isArray(data)
        ? (data[0] as BusinessGroupEntity | undefined)
        : (data as BusinessGroupEntity | undefined);
    },
    enabled: Boolean(id),
  });
}
